"use client";

import { motion } from "framer-motion";
import BlogCard from "@/components/blog/BlogCard";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";
import type { BlogCardData } from "@/lib/blog";

/** „Das könnte dich auch interessieren" – verwandte Artikel. */
export default function RelatedPosts({ articles }: { articles: BlogCardData[] }) {
  if (!articles.length) return null;
  return (
    <section className="cv-auto bg-paper border-t border-line py-20 lg:py-24" aria-labelledby="related-posts-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          variants={stagger(0.09)}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="flex flex-col gap-4 mb-10"
        >
          <motion.p
            variants={fadeUp}
            className="flex items-center gap-3 text-xs font-bold uppercase tracking-widest text-ink-faint"
          >
            <span className="w-1.5 h-1.5 bg-accent shrink-0" aria-hidden="true" />
            Weiterlesen
          </motion.p>
          <motion.h2
            variants={fadeUp}
            id="related-posts-heading"
            className="font-display font-bold text-3xl sm:text-4xl tracking-tight leading-[1.1] text-ink"
          >
            Das könnte dich auch interessieren
          </motion.h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 items-stretch">
          {articles.map((article, i) => (
            <BlogCard key={article.slug} article={article} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
